import { Connection } from "./Connection.model";

export class EventConnection extends Connection {
    public eventConnectionString!: string
}